function owlCarousel() {
  $(document).ready(function(){
    $('.quick-access__list').owlCarousel({
      loop:true,
      responsiveClass:true,
      responsive:{
        0:{
          items:1,
          nav:true
        },
        600:{
          items:3,
          nav:false
        },
        1050:{
          items:5,
          nav:true,
          loop:true
        }
      }
    });
    $('.agenda-list').owlCarousel({
      loop:true,
      margin:10,
      responsiveClass:true,
      responsive:{
        0:{
          items:1,
          nav:true
        },
        600:{
          items:2,
          nav:false
        },
        1000:{
          items:3,
          nav:true,
          loop:false
        }
      }
    });
    $('.actualities-list').owlCarousel({
      loop:true,
      margin:10,
      responsiveClass:true,
      responsive:{
        0:{
          items:1,
          nav:true
        },
        600:{
          items:2,
          nav:true
        },
        1000:{
          items:3,
          nav:true
        }
      }
    });
    $('.en-images__img-list2').owlCarousel({
      loop:true,
      margin:10,
      responsiveClass:true,
      responsive:{
        0:{
          items:1,
          nav:true
        },
        800:{
          items:1,
          nav:true
        },
        1000:{
          items:3,
          nav:false
        }
      }
    });
  });
}
